export const SHOP_TYPE = {
  0: '全部',
  1: '直营',
  2: '加盟',
  3: '联营'
}

export const filterToArrayList = function (obj) {
  const arr = []
  Object.keys(obj).forEach(item => {
    arr.push({ label: obj[item], val: item, value: item })
  })
  return arr
}

// 计算方式
export const SETTLE_TYPE = {
  0: '非法人结算',
  1: '法人结算'
}

// 结算对象
export const SETTLE_TO_TYPE = {
  0: '结算给自己',
  1: '结算给总店'
}
